import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import 'styles/index.css'
import { ID } from 'containers/constants'
import registerServiceWorker from './registerServiceWorker'
import store, { history } from './store'
import App from './containers/App/App'

const target = document.querySelector(ID.COVET_CHAT_APP_ELEMENT)

render(
  <Provider store={store}>
    <App />
  </Provider>,
  target
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js